import { z } from "zod";
import { RequestParameterTypeEnum, RequestParameterTypeEnumSchema } from "../Enums/RequestParameterTypeEnum";
import { LinkedButtonWhenEnumSchema } from "../Enums/LinkedButtonWhenEnum";
import { LinkedOdvetvieIdDtoSchema } from "./LinkedOdvetvieIdDto";
import { RequestValidationErrorTypeSchema } from "../Enums/RequestValidationErrorType";
import { DisplayTextDisplayTypeEnumSchema } from "../Enums/DisplayTextDisplayTypeEnum";
import { NoticeDisplayTypeEnumSchema } from "../Enums/NoticeDisplayTypeEnum";

export const RequestFieldDtoSchema = z.object({
    id: z.string(),
    name: z.string().nullish(),
    key: z.string().nullish(),
    type: RequestParameterTypeEnumSchema,
    description: z.string().nullish(),
    minLength: z.number().nullish(),
    maxLength: z.number().nullish(),
    required: z.boolean(),
    validationSQL: z.string().nullish(),
    validationRegex: z.string().nullish(),
    validationErrorMessage: z.string().nullish(),
    dataMask: z.string().nullish(),
    uiHint: z.string().nullish(),
    requestTypeId: z.number(),
    fieldTypeId: z.number(),
    parentSectionId: z.string(),
    order: z.number(),
    parameterText: z.string().nullish(),
    isDocumentRecordId: z.boolean(),
    autoUseSelfPartnerId: z.boolean(),
    group: z.string().nullish(),
    linkedButtonKey: z.string().nullish(),
    linkedButtonWhen: LinkedButtonWhenEnumSchema.nullish(),
    linkedOdvetvie: z.array(LinkedOdvetvieIdDtoSchema),
    isDisabled: z.boolean(),
    atLeastOneRequiredWithinGroup: z.boolean(),
    fieldsRelationRequired: z.boolean().nullish(),
    fieldsRelationMaster: z.boolean().nullish(),
    displayType: z.number().nullish(),
    paramValue: z.any().nullish(), // Added by FE
    hidden: z.boolean().nullish(), // Added by FE
    isIdFieldInvalid: z.boolean().nullish(), // Added by FE
    requestValidationErrorType: RequestValidationErrorTypeSchema.nullish(), // Added by FE
    displayTitle: z.string().nullish(), // Added by FE
    invalidErrorMessage: z.string().nullish(), // Added by FE
    save: z.boolean().nullish(), // Added by FE
    prefilledFromQueryParam: z.boolean().nullish(), // Added by FE
}).superRefine((field, ctx) => {
    if (field.type === RequestParameterTypeEnum.DISPLAY_TEXT) {
        if (!DisplayTextDisplayTypeEnumSchema.nullish().safeParse(field.displayType).success) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ["displayType"],
                message: "displayType must be a valid DisplayTextDisplayTypeEnum value for a DISPLAY_TEXT field.",
            });
        }
    } else if (field.type === RequestParameterTypeEnum.NOTICE) {
        if (!NoticeDisplayTypeEnumSchema.nullish().safeParse(field.displayType).success) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ["displayType"],
                message: "displayType must be a valid NoticeDisplayTypeEnum value for a NOTICE field.",
            });
        }
    }
});

export type RequestFieldDto = z.infer<typeof RequestFieldDtoSchema>;